import { useState } from 'react';
import { logStepResponse } from '../../../utils/experimentLog';

// フェーズごとの問いかけ。X-2（shape-change／gaze-control）はおかしさの原因と直し方を問う
// （2026-10-14。旧＝直し方だけを問う文で、穴埋めの文型＝顕在化→帰属→既存知識→直し方と合っていなかった）。
// X-1 では説明を書かせない（2026-10-14週例。部品の確認は PartConfirmPanel）。
const PROMPT_BY_PHASE = {
  'shape-change': 'このデッサンのおかしさの原因と直し方を、気付いていない人に伝える文にまとめましょう。',
  'gaze-control': 'このデッサンのおかしさの原因と直し方を、気付いていない人に伝える文にまとめましょう。',
};

export function getSelfExpPrompt(phase) {
  return PROMPT_BY_PHASE[phase] || 'この誤りをどのように修正すればよいですか？';
}

// 自己説明の送信処理（Supabase の step_responses ＋ option_selections。2026-10-10 に
// Flask /selfexp への保存を廃止し、同日 experiment_logs の selfexp_submit から専用の表へ移した）。
// 取り組み（学習者番号）・演習・問番号・ステップ・所要時間は logStepResponse が演習の文脈から付ける。
// 説明シート（SelfExpPanel）から呼ぶ。送信内容の組み立てをここ1か所に集約している。
// submit() は送信済みの回答文字列を返す（送信失敗時も回答は返し、演習は止めない）。
export function useSelfExpSubmit({ number, phase, errorGlbPath, selectedPart }) {
  const [submitting, setSubmitting] = useState(false);
  const prompt = getSelfExpPrompt(phase);

  const submit = async ({ answerText, answerMode, selectedOptions = null, templateUsed = false }) => {
    setSubmitting(true);
    const answer = (answerText || '').trim();
    try {
      // Supabaseへ送信（送れなかった分は端末のキューに残して再送する）
      logStepResponse({
        selectedPart,
        selfExplanation: answer,
        answerMode,
        templateUsed,
        prompt,
        selectedOptions,
      });
      return answer;
    } finally {
      setSubmitting(false);
    }
  };

  return { prompt, submitting, submit };
}
